import { NgModule } from '@angular/core';
import { SwipeDirective } from './swipe/swipe';
import { VisualMaskDirective } from './visual-mask/visual-mask.directive';
@NgModule({
	declarations: [SwipeDirective, VisualMaskDirective],
	imports: [],
	exports: [SwipeDirective, VisualMaskDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts